const IconExclude = () => {
    return (
        <svg
            width="15"
            height="14"
            viewBox="0 0 15 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.5 14C11.366 14 14.5 10.866 14.5 7C14.5 3.13401 11.366 0 7.5 0C3.63401 0 0.5 3.13401 0.5 7C0.5 10.866 3.63401 14 7.5 14ZM4.8103 3.29455L7.50001 5.97193L10.1897 3.29455L11.2225 4.32263L8.53282 7L11.2225 9.67738L10.1897 10.7055L7.50001 8.02808L4.8103 10.7055L3.7775 9.67738L6.4672 7L3.7775 4.32263L4.8103 3.29455Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default IconExclude;
